export const USAGE_DATA_REFRESH_EVENT = 'elora:usage-data-refresh';
